module.exports = __webpack_public_path__ + "static/img/89101G_1_C_20210209_LC.c68449a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89101G_1_C_20210209_LC.png
// module id = zn+h
// module chunks = 0